import { render, staticRenderFns } from "./configuration-view.vue?vue&type=template&id=00b2e08b&"
import script from "./configuration-view.vue?vue&type=script&lang=ts&"
export * from "./configuration-view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports